:root {
  --scrollbar-thumb: 'rgba(0, 0, 0, 0.4)';
  --scrollbar-track: transparent;
}

/*
 * Apply CSS font smoothing on the root web container. Without this, text
 * renders blurry / overly bold on macOS Chrome and Safari because those
 * browsers default to subpixel antialiasing for Latin text. Switching to
 * grayscale antialiasing matches the rendering used by most modern web
 * design systems and what we see in our Figma designs.
 */
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* WebKit browsers */
::-webkit-scrollbar {
  width: 8px;
}
::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}
::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 4px;
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
}

/*
 * Prevent mobile browsers (iOS Safari, Android Chrome) from auto-zooming
 * when an input is focused. The browser triggers a zoom-in whenever the
 * focused field has a font-size below 16px to make the text legible, which
 * causes a jarring layout shift on mobile web.
 *
 * Forcing a 16px minimum on form controls keeps the viewport stable on
 * focus. Scoped to widths below the `sm` breakpoint (733px, see
 * src/style/breakpoints.ts) so desktop inputs keep their designed sizes.
 * !important is required to win against the inline styles that
 * react-native-web and third-party form libraries set on these elements.
 */
@media (max-width: 732px) {
  input,
  textarea,
  select {
    font-size: 16px !important;
  }
}

/*
 * Chrome/WebKit paint a hard-coded pale background on autofilled inputs that
 * ignores our inline (themed) background color. The background can't be set
 * directly, but pushing the autofill background/text transition effectively
 * infinitely into the future keeps the field showing its own themed colors.
 */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  transition:
    background-color 9999999s ease-in-out 0s,
    color 9999999s ease-in-out 0s !important;
}
